import classNames from 'classnames';
import { PropsWithChildren } from 'react';
import { HiCheck } from 'react-icons/hi';

export type AutocompleteItemProps = {
  className?: string;
  selected?: boolean;
  active?: boolean;
};

export function AutocompleteItem({ children, className, active, selected }: PropsWithChildren<AutocompleteItemProps>) {
  return (
    <div className={classNames('relative cursor-pointer autocomplete-none px-1 py-0.5', className)}>
      <div
        className={classNames(
          'rounded py-1.5 pl-5 pr-3',
          active && 'bg-brand-primary text-black',
          !active && 'text-gray-900',
        )}
      >
        <span className={classNames('block truncate', selected && 'font-medium pr-5', !selected && 'font-normal')}>
          {children}
        </span>
        {selected ? (
          <span
            className={classNames(
              'absolute inset-y-0 right-0 flex items-center pl-1 pr-3',
              active && 'text-white',
              !active && 'text-sky-600',
            )}
          >
            <HiCheck className="h-5 w-5" strokeWidth={1} />
          </span>
        ) : null}
      </div>
    </div>
  );
}

export default AutocompleteItem;
